<template>
  <div>
      <table width="100%" class="vs-table vs-table--tbody-table ">
          <tr>
              <td class="td vs-table--td" style="padding: 5px">
                  Customer/Ship-to Code
              </td>
              <td class="td vs-table--td" style="padding: 5px">
                  {{ ': ' + this.data.customer_code}}
              </td>
          </tr>
          <tr>
              <td class="td vs-table--td" style="padding: 5px">
                  SO/Invoice Code
              </td>
              <td class="td vs-table--td" style="padding: 5px">
                  {{ ': ' + this.data.so_code}}
              </td>
          </tr>
          <tr>
              <td class="td vs-table--td" style="padding: 5px">
                  Sales Return Data
              </td>
              <td class="td vs-table--td" style="padding: 5px">
                  {{ ': ' + this.data.sales_return_data}}
              </td>
          </tr>
          <tr>
              <td class="td vs-table--td" style="padding: 5px">
                 Receive Date
              </td>
              <td class="td vs-table--td" style="padding: 5px">
                  {{ ': '+ formatDate(this.data.receive_date) }}
              </td>
          </tr>
          <tr>
              <td class="td vs-table--td" style="padding: 5px">
                 Note
              </td>
              <td class="td vs-table--td" style="padding: 5px">
                  {{ ': ' + this.data.note}}
              </td>
          </tr>
      </table>

      <vs-divider style="width: 100%; margin-left: 0%"></vs-divider>
      <table width="100%" class="vs-table vs-table--tbody-table print">
          <thead class="vs-table--thead">
              <tr>
                <th width="10%">SKU Code</th>
                <th width="15%">SKU Description</th>
                <th width="10%">HU</th>
                <th width="10%">Qty Receive</th>
                <th width="10%">ED</th>
                <th width="10%">Batch</th>
                <th width="10%">Checked Status</th>
                <th width="10%">Qty Putaway</th>
                <th width="15%">Suggested Warehouse Area</th>
              </tr>
          </thead>
          <tbody>
                <tr v-for="(item) in normalItems" :key="'normal-' + item.uid" style="padding-bottom: 5px">
                  <td class="td vs-table--td" style="padding: 5px">
                    {{ item.item_code }}
                  </td>
                  <td class="td vs-table--td" style="padding: 5px">
                    {{ item.item_name }}
                  </td>
                  <td class="td vs-table--td" style="padding: 5px">
                    {{ item.item_unit_receive }}
                  </td>
                  <td class="td vs-table--td" style="padding: 5px">
                    {{ item.qty }}
                  </td>
                  <td class="td vs-table--td" style="padding: 5px">
                    {{ formatDate(item.expired_date) }}
                  </td>
                  <td class="td vs-table--td" style="padding: 5px">
                    {{ item.batch }}
                  </td>
                  <td class="td vs-table--td" style="padding: 5px">
                    {{ item.checked_status }}
                  </td>
                  <td class="td vs-table--td" style="padding: 5px">
                    {{ item.qty_putaway }}
                  </td>
                  <td class="td vs-table--td" style="padding: 5px">
                    {{ item.wh_name }}
                  </td>
              </tr>
          </tbody>
      </table>

      <vs-divider style="width: 100%; margin-left: 0%">Combo Items</vs-divider>
      <table width="100%" class="vs-table vs-table--tbody-table print">
          <thead class="vs-table--thead">
              <tr>
                <th width="12%">Combo Information</th>
                <th width="5%">Receive Qty</th>
                <th width="7%">SKU Code</th>
                <th width="10%">SKU Description</th>
                <th width="5%">HU</th>
                <th width="5%">Qty</th>
                <th width="8%">ED</th>
                <th width="8%">Batch</th>
                <th width="5%">Checked Status</th>
                <th width="5%">Qty Putaway</th>
                <th width="15%">Suggested Warehouse Area</th>
              </tr>
          </thead>
          <tbody>
                <template v-for="group in groupedComboItems">
                    <tr
                    v-for="(item, index) in group.items"
                    :key="'group-' + group.combo_id + '-item-' + item.uid"
                    class="combo-row"
                    :style="index === 0
                        ? 'border-top: 2px solid #d8d8d8; padding-bottom: 5px;'
                        : 'padding-bottom: 5px;'"
                    >
                    <!-- Combo info hanya tampil di baris pertama -->
                    <td
                        v-if="index === 0 && isFirstComboGroup(group)"
                        class="td vs-table--td"
                        style="padding: 5px; background: #fafafa;"
                        :rowspan="comboItems.filter(i => i.combo_id === group.combo_id).length"
                        >
                        <div>
                            <strong>Combo Code :</strong> {{ group.combo_code }} <br>
                            <strong>Combo Name :</strong> {{ group.combo_name }} <br>
                            <strong>Qty :</strong> {{ group.qty_combo }} SET
                        </div>

                        <div
                            v-for="comboItem in group.items.filter(item => !item.is_child_combo)"
                            :key="'combo-info-' + comboItem.uid"
                            style="margin-top: 8px; padding-top: 6px; border-top: 1px dashed #d8d8d8;"
                        >
                            <strong>{{ comboItem.item_code }}</strong><br>
                            {{ comboItem.item_name }}<br>
                            Qty : {{ comboItem.quantity }}
                        </div>
                    </td>

                    <!-- Receive qty hanya tampil di baris pertama -->
                    <td
                        v-if="index === 0"
                        class="td vs-table--td"
                        style="padding: 5px"
                        :rowspan="group.items.length"
                    >
                    {{ group.combo_qty_receive }}
                    </td>

                    <!-- Detail item -->
                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.item_code }}
                    </td>

                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.item_name }}
                    </td>

                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.item_unit }}
                    </td>

                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.qty }}
                    </td>

                    <td class="td vs-table--td" style="padding: 5px">
                        {{ formatDate(item.expired_date) }}
                    </td>

                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.batch }}
                    </td>

                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.checked_status }}
                    </td>

                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.qty_putaway }}
                    </td>

                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.wh_name }}
                    </td>
                    </tr>

                </template>
          </tbody>
      </table>

      <div class="flex justify-center w-full pt-6 print-button">
            <div
            style="
                position: absolute;
                left: 50%;
                -ms-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
            ">
                <vs-button class="mr-2 mb-3 mt-12" color="danger" @click="handleBack()">Close</vs-button>
                <vs-button class="mr-2 mb-3 mt-12" color="primary" @click="handlePrint()">Print</vs-button>
            </div>
        </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  components: {
  },
  mounted() {
      this.id = this.$route.params.id;
      this.mode = this.$route.params.mode;
      this.initData();
  },
  data() {
      return {
          dialog: {
              save: false,
          },
          id: null,
          attachment: null,
          data: {
                id: null,
                customer_code: null,
                so_code: null,
                code: null,
                gir_number: null,
                sales_return_data: null,
                receive_date: null,
                note: null,
                file: null,
                status: null,
                // fileUrl: '',
              },
            // items: [{
            //     item_code: '',
            //     item_name: '',
            //     item_unit_receive: '',
            //     qty: '',
            //     batch: '',
            //     expired_date: '',
            //     warehouse_area: '',
            //     checked_status: '',
            // }],
            items: [],
            statusReadonly: false,
      }
  },
  methods: {
      async handlePrint() {
          await window.print();
      },
      initData() {
          this.$http
              .get(this.$store.state.inbound.customerReturn.baseUrlPath + "/putaway/" + this.id)
              .then((resp) => {
                  console.log(resp)
                  if (resp.code == 200) {
                    var now = moment().toDate();
                        this.data.id = resp.data.sr_id
                        this.data.customer_code = resp.data.customer_code
                        this.data.so_code = resp.data.so_code
                        this.data.so_id = resp.data.so_id
                        this.data.sales_return_data = resp.data.code + " " + resp.data.gir_number
                        this.data.code = resp.data.code
                        this.data.gir_number = resp.data.gir_number
                        this.data.receive_date = resp.data.receive_date == null ? now : resp.data.receive_date
                        this.data.note = resp.data.note
                        this.data.status = resp.data.status
                        var sameitem = ""
                        // this.items = resp.data.lines
                        resp.data.lines.forEach(el =>{
                            let expired_date = null
                            let batch = ""
                            console.log('ed',el.expired_date)
                            if(el.expired_date == "0001-01-01T00:00:00Z"){
                                expired_date = null
                            } else {
                                expired_date = el.expired_date
                            }
                            if(el.batch == "0000"){
                                batch = ""
                            } else {
                                batch = el.batch
                            }
                            let status_shelf_life_view = ""

                            if (el.shelf_life_status) {
                                const status = el.shelf_life_status.toLowerCase();

                                if (status.includes("passed")) {
                                    status_shelf_life_view = "Passed";
                                } else if (status.includes("failed")) {
                                    status_shelf_life_view = `Shelf Life < ${el.shelf_life_day} Day`;
                                }
                            }
                          const newItem = {
                            item_code: el.item_code,
                            item_name: el.item_name,
                            item_unit: el.item_unit,
                            item_unit_receive: el.item_unit_receive,
                            quantity: el.return_qty,
                            pickup_qty: el.pickup_qty,
                            qty: el.qty,
                            batch: batch,
                            expired_date: expired_date,
                            checked_status: el.checked_status,
                            qty_putaway: el.qty_putaway,
                            wh_name: el.wh_name,
                            select_warehouse_area: {
                              id: el.warehouse_area,
                              name: '',
                            },
                            srp_id: el.srp_id,
                            sr_line_id: el.srrl_line_id,
                            wh_id: el.wh_id,
                            supplier: el.supplier_code + " - " + el.supplier_name,
                            shelf_life_id: el.shelf_life_id,
                            shelf_life_day: el.shelf_life_day,
                            shelf_life_status: el.shelf_life_status,
                            shelf_life_status_view: status_shelf_life_view,
                            combo_id: el.combo_id,
                            combo_code: el.combo_code,
                            combo_name: el.combo_name,
                            qty_combo: el.qty_combo,
                            combo_group: el.sales_return_receive_combo_id ? el.sales_return_receive_combo_id : null,
                            combo_qty_receive: el.combo_qty_receive,
                            qty_per_set: el.qty_per_set,
                            is_child_combo: (sameitem == el.item_code + el.item_unit + el.return_qty) ? true : false,
                            uid: `${el.sales_return_line_id}-${this.items.length}`,
                          }
                          this.items.push(newItem)
                          sameitem = el.item_code + el.item_unit + el.return_qty
                        })
                  } else {
                  }
              });
      },
        handleBack() {
            this.$router.push({
                name: this.$store.state.inbound.customerReturn.baseRouterName,
            });
        },
        isFirstComboGroup(group) {
            const firstGroup = this.groupedComboItems.find(
                g => g.combo_id === group.combo_id
            )

            return firstGroup && firstGroup.combo_group === group.combo_group
        },
    },
  computed: {
        formatDate: () => {
            return (val) => {
                const momentDate = moment.utc(val);
                return momentDate.format('DD MMM YYYY');
            };
        },
        normalItems() {
            return this.items.filter(item => !item.combo_id || item.combo_id === 0)
        },
        comboItems() {
            return this.items.filter(item => item.combo_id && item.combo_id !== 0)
        },
        groupedComboItems() {
            const grouped = {}
            const firstComboGroupMap = {}

            this.comboItems.forEach(item => {
                const groupKey = item.combo_group || `${item.combo_id}-0`

                // simpan combo_group pertama
                if (!firstComboGroupMap[item.combo_id]) {
                    firstComboGroupMap[item.combo_id] = groupKey
                }

                // tentukan child_item
                const childItem =
                    firstComboGroupMap[item.combo_id] !== groupKey

                if (!grouped[groupKey]) {
                    grouped[groupKey] = {
                        combo_group: groupKey,
                        combo_id: item.combo_id,
                        combo_code: item.combo_code,
                        combo_name: item.combo_name,
                        qty_combo: item.qty_combo,
                        combo_qty_receive: item.combo_qty_receive == null ? '' : item.combo_qty_receive,
                        child_item: childItem,
                        items: []
                    }
                }

                grouped[groupKey].items.push({
                    ...item,
                    child_item: childItem
                })
            })

            return Object.values(grouped)
        }
    },
}
</script>
<style>
/* Set the page size to A4 and the orientation to landscape */
@page {
  size: A4 landscape;
}

/* Set the font size to 12px for printing */
@media print {
  body {
      font-size: 12px;
      background: none !important;
  }

  * {
      background: none !important;
  }

  header,
  footer,
  .print-button,
  #content-area * :not(.content-wrapper *) {
      display: none !important;
      visibility: hidden !important;
  }

  .router-view,
  .router-content {
      padding: 0 !important;
      margin: 0 !important;
  }
}

table.print {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  margin-top: 20px;
}

table.print td,
table.print th {
  border: 1px solid #abab !important;
  text-align: left;
  padding: 8px;
}
</style>
